// Solution from https://www.jstips.co/en/javascript/get-file-extension/
// returns extension without the FULL STOP token in lower case
export const getExtensionFromFileName = (fileName) =>
  /[.]\w/.exec(fileName) ? /[^.]+$/.exec(fileName)[0].toLowerCase() : undefined;
